export enum ChannelType {
    Storefront = 'storefront',
    Punchout = 'punchout',
    Marketplace = 'marketplace',
    Api = 'api',
    Pos = 'pos',
}